<nz-card class="gic-table-card">
  <div class="table-wrapper">
    <nz-table [nzData]="rows" [nzFrontPagination]="false" [nzShowPagination]="false" [ngClass]="densityClass" [nzLoading]="loading" [nzLoadingDelay]="200">
      <thead>
        <tr>
          <!-- Proveedor (texto) -->
          @if (visibleCols.provider) {
          <th scope="col" scope="col" nzShowSort [nzSortOrder]="sortKey === 'provider' ? sortOrder : null" (nzSortOrderChange)="onSort('provider', $event)">
            <b>Proveedor</b>
          </th>
          }

          <!-- Nombre del catálogo (texto) -->
          @if (visibleCols.name) {
          <th scope="col" scope="col" nzShowSort [nzSortOrder]="sortKey === 'name' ? sortOrder : null" (nzSortOrderChange)="onSort('name', $event)">
            <b>Nombre del Catálogo</b>
          </th>
          }

          <!-- Tarifa (número o texto, según tu modelo) -->
          @if (visibleCols.rate) {
          <th scope="col" scope="col" nzShowSort [nzSortOrder]="sortKey === 'rate' ? sortOrder : null" (nzSortOrderChange)="onSort('rate', $event)">
            <b>Tarifa</b>
          </th>
          }

          <!-- Fechas -->
          @if (visibleCols.receivedAt) {
          <th scope="col" scope="col" nzShowSort [nzSortOrder]="sortKey === 'receivedAt' ? sortOrder : null" (nzSortOrderChange)="onSort('receivedAt', $event)">
            <b>Fecha de Recepción</b>
          </th>
          } @if (visibleCols.publishedAt) {
          <th scope="col" scope="col" nzShowSort [nzSortOrder]="sortKey === 'publishedAt' ? sortOrder : null" (nzSortOrderChange)="onSort('publishedAt', $event)">
            <b>Fecha de Publicación</b>
          </th>
          } @if (visibleCols.effectiveDate) {
          <th scope="col" scope="col" nzShowSort [nzSortOrder]="sortKey === 'effectiveDate' ? sortOrder : null" (nzSortOrderChange)="onSort('effectiveDate', $event)">
            <b>Fecha de Entrada en vigor</b>
          </th>
          } @if (visibleCols.importDate) {
          <th scope="col" scope="col" nzShowSort [nzSortOrder]="sortKey === 'importDate' ? sortOrder : null" (nzSortOrderChange)="onSort('importDate', $event)">
            <b>Fecha de Importación</b>
          </th>
          } @if (visibleCols.importPfDate) {
          <th scope="col" scope="col" nzShowSort [nzSortOrder]="sortKey === 'importPfDate' ? sortOrder : null" (nzSortOrderChange)="onSort('importPfDate', $event)">
            <b>Fecha de Importación en PF</b>
          </th>
          } @if (visibleCols.status) {
          <th scope="col"><b>Estado</b></th>
          } @if (visibleCols.typeCatalog) {
          <th scope="col"><b>Tipo catálogo</b></th>
          } @if (visibleCols.assignments) {
          <th scope="col"><b>Asignaciones</b></th>
          } @if (visibleCols.actions) {
          <th scope="col" class="actions-th"><b>Acciones</b></th>
          }
        </tr>
      </thead>

      <tbody>
        @for (row of rows | slice:(pageIndex-1)*pageSize:(pageIndex)*pageSize; track trackByRow($index, row)) {
        <tr>
          @if (visibleCols.provider) {
          <td>{{ row.provider }}</td>
          } @if (visibleCols.name) {
          <td>{{ row.name }}</td>
          } @if (visibleCols.rate) {
          <td>{{ row.rate }}</td>
          } @if (visibleCols.receivedAt) {
          <td>{{ row.receivedAt === '1/1/1970' ? '-' : row.receivedAt || '-' }}</td>
          } @if (visibleCols.publishedAt) {
          <td>{{ row.publishedAt === '1/1/1970' ? '-' : row.publishedAt || '-' }}</td>
          } @if (visibleCols.effectiveDate) {
          <td>{{ row.effectiveDate === '1/1/1970' ? '-' : row.effectiveDate || '-' }}</td>
          } @if (visibleCols.importDate) {
          <td>{{ row.importDate === '1/1/1970' ? '-' : row.importDate || '-' }}</td>
          } @if (visibleCols.importPfDate) {
          <td>{{ row.importPfDate === '1/1/1970' ? '-' : row.importPfDate || '-' }}</td>
          } @if (visibleCols.status) {
          <td>
            <nz-tag class="state-tag" [ngClass]="stateClass(row.state)">
              {{ stateLabel(row.state) }}
            </nz-tag>
          </td>
          } @if (visibleCols.typeCatalog) {
          <td>
            @if (row.tipo_catalogo === 1) {
            <span>
              {{ 'Lentes' }}
            </span>
            } @if (row.tipo_catalogo === 2) {
            <span>
              {{ 'Lentillas' }}
            </span>
            } @if (row.tipo_catalogo === 3) {
            <span>
              {{ 'Otros' }}
            </span>
            }
          </td>
          }
          <!-- Asignaciones -->
          @if (visibleCols.assignments) {
          <td>
            <button
              nz-button
              nzType="link"
              type="button"
              [attr.aria-label]="row.groupLabel || 'Sin asignación'"
              (click)="onAction('assign', row, { onlyView: true, noButtons: true })"
            >
              @if (row.groupLabel === 'Sin asignación') {
              <i nz-icon nzType="link" class="add-ico"></i>
              }
              {{ row.groupLabel || 'Sin asignación' }}
            </button>
          </td>
          }
          <!-- Acciones -->
          @if (visibleCols.actions) {
          <td class="actions-td">
            @if (row.originalState === 'PUBLICADO') {
            <button nz-button nzSize="small" class="action-btn action-btn--primary" type="button" (click)="onAction('assign', row)">
              <i nz-icon nzType="user-add"></i><span>Asignar</span>
            </button>
            } @if (row.state === 'TO_PUBLISH') {
            <button nz-button nzSize="small" class="action-btn action-btn--primary" type="button" (click)="onAction('schedule', row)">
              <i nz-icon nzType="play-circle"></i><span>Re-Programar</span>
            </button>
            } @if (row.state === 'PEND_IMPORT' || row.state === 'IMPORT_FAILED') {
            <button nz-button nzSize="small" class="action-btn action-btn--primary" type="button" (click)="onAction('import', row)">
              <i nz-icon nzType="upload"></i><span>Importar</span>
            </button>
            } @if (row.state === 'PUBLISHED NEVER WORK') {
            <!-- El botón de historial nunca estará disponible, porque Anto me ha dicho que no tenemos historial -->
            <button nz-button nzSize="small" class="action-btn action-btn--ghost" type="button" (click)="clickHistory.emit(row)">
              <i nz-icon nzType="eye"></i><span>Historial</span>
            </button>
            }
          </td>
          }
        </tr>
        }
      </tbody>
    </nz-table>
  </div>

  <div class="pager-bar">
    @if (rows.length) {
    <div class="pager-extra">
      <span><b>Total:</b> {{ rows.length }} elementos</span>
    </div>
    }
    <!-- Paginador primero -->

    <nz-pagination
      [nzTotal]="rows.length"
      [(nzPageIndex)]="pageIndex"
      [(nzPageSize)]="pageSize"
      [nzPageSizeOptions]="[4, 10, 25]"
      nzShowSizeChanger
      nzShowQuickJumper
      (nzPageIndexChange)="pageIndexChange.emit($event)"
      (nzPageSizeChange)="pageSizeChange.emit($event)"
      class="pager"
    >
    </nz-pagination>

    <!-- A la derecha del paginador: total + botón -->
    @if (rows.length) {
    <div class="pager-extra">
      <button nz-button nzType="default" type="button" aria-label="Actualizar catálogo" (click)="onRefresh()">
        <i nz-icon nzType="reload"></i>
      </button>
    </div>
    }
  </div>
</nz-card>
